let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cVHxt")).then(() => parcelRequire('4J30H'));